import { ISimpleSelectItem } from '../../components/select/SimpleSelect';
import { PillColor } from '../../components/pill/Pill';
import {
  OrderStatus,
  PurchaseStatus,
  SaleStatus,
  OrderOrigin,
  BusinessUnit as GraphqlBusinessUnit,
} from 'src/types/enums';
import { BusinessUnit } from './enums';

export const ORDER_ORIGINS: Record<OrderOrigin, string> = {
  [OrderOrigin.AiEntry]: 'AI Entry',
  [OrderOrigin.Manual]: 'Intern manueel',
  [OrderOrigin.CustomerPortal]: 'Klantenportaal',
  [OrderOrigin.Transporeon]: 'Transporeon',
  [OrderOrigin.Api]: 'API',
};

export const PURCHASE_STATUS_OPTIONS: ISimpleSelectItem[] = [
  {
    key: PurchaseStatus.Created,
    name: 'Aangemaakt',
  },
  {
    key: PurchaseStatus.Confirmed,
    name: 'Bevestigd',
  },
  {
    key: PurchaseStatus.SelfBillCreated,
    name: 'Self-bill aangemaakt',
  },
  {
    key: PurchaseStatus.Invoiced,
    name: 'Gefactureerd',
  },
];

export const PURCHASE_STATUS_COLOR: Record<PurchaseStatus, PillColor> = {
  [PurchaseStatus.Created]: 'neutral',
  [PurchaseStatus.Confirmed]: 'positive',
  [PurchaseStatus.SelfBillCreated]: 'positive',
  [PurchaseStatus.Invoiced]: 'positive',
};

export const SALE_STATUS_OPTIONS: ISimpleSelectItem[] = [
  {
    key: SaleStatus.Created,
    name: 'Aangemaakt',
  },
  {
    key: SaleStatus.Incomplete,
    name: 'Onvolledig',
  },
  {
    key: SaleStatus.Invoiced,
    name: 'Gefactureerd',
  },
  {
    key: SaleStatus.Credited,
    name: 'Gecrediteerd',
  },
];

export const SALE_STATUS_COLOR: Record<SaleStatus, PillColor> = {
  [SaleStatus.Created]: 'neutral',
  [SaleStatus.Incomplete]: 'primary',
  [SaleStatus.Invoiced]: 'positive',
  [SaleStatus.Credited]: 'negative', // should this be negative or neutral?
};

export const ORDER_STATUS_OPTIONS: ISimpleSelectItem[] = [
  {
    key: OrderStatus.Draft,
    name: 'In Opmaak',
  },
  {
    key: OrderStatus.Created,
    name: 'Aangemaakt',
  },
  {
    key: OrderStatus.Prepayment,
    name: 'Vooruitbetaling',
  },
  {
    key: OrderStatus.Placed,
    name: 'Geplaatst',
  },
  {
    key: OrderStatus.Confirmed,
    name: 'Bevestigd',
  },
  {
    key: OrderStatus.Refused,
    name: 'Geweigerd',
  },
  {
    key: OrderStatus.Executed,
    name: 'Uitgevoerd',
  },
  {
    key: OrderStatus.Cancelled,
    name: 'Geannuleerd',
  },
];

export const ORDER_STATUS_COLOR: Record<OrderStatus, PillColor> = {
  [OrderStatus.Draft]: 'neutral',
  [OrderStatus.Created]: 'neutral',
  [OrderStatus.Prepayment]: 'primary',
  [OrderStatus.Placed]: 'positive',
  [OrderStatus.Confirmed]: 'positive',
  [OrderStatus.Refused]: 'negative',
  [OrderStatus.Executed]: 'positive',
  [OrderStatus.Cancelled]: 'negative',
};

export function graphqlBusinessUnitToNativeBusinessUnit(bu: GraphqlBusinessUnit): BusinessUnit {
  switch (bu) {
    case GraphqlBusinessUnit.Benelux:
      return BusinessUnit.Benelux;
    case GraphqlBusinessUnit.France:
      return BusinessUnit.France;
    case GraphqlBusinessUnit.Germany:
      return BusinessUnit.Germany;
    case GraphqlBusinessUnit.Forwarding:
      return BusinessUnit.Forwarding;
    default:
      return BusinessUnit.Benelux; // default to Benelux
  }
}

export function nativeBusinessUnitToGraphqlBusinessUnit(bu: BusinessUnit): GraphqlBusinessUnit {
  switch (bu) {
    case BusinessUnit.Benelux:
      return GraphqlBusinessUnit.Benelux;
    case BusinessUnit.France:
      return GraphqlBusinessUnit.France;
    case BusinessUnit.Germany:
      return GraphqlBusinessUnit.Germany;
    case BusinessUnit.Forwarding:
      return GraphqlBusinessUnit.Forwarding;
    default:
      return GraphqlBusinessUnit.Benelux; // default to Benelux
  }
}

export const BUSINESS_UNIT_OPTIONS: ISimpleSelectItem[] = [
  {
    key: GraphqlBusinessUnit.Benelux,
    name: 'Benelux',
  },
  {
    key: GraphqlBusinessUnit.France,
    name: 'Frankrijk',
  },
  {
    key: GraphqlBusinessUnit.Germany,
    name: 'Duitsland',
  },
  {
    key: GraphqlBusinessUnit.Forwarding,
    name: 'Forwarding',
  },
];
